import { render, staticRenderFns } from "./DanhSachVaiTroTheoNguoiDung.vue?vue&type=template&id=4c921b03&"
import script from "./DanhSachVaiTroTheoNguoiDung.vue?vue&type=script&lang=js&"
export * from "./DanhSachVaiTroTheoNguoiDung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports